import { useRef, useState } from 'react';
import type { DragEvent, ChangeEvent } from 'react';

interface Props {
  onFileSelected: (file: File) => void;
  accept?: string;
}

const DEFAULT_ACCEPT = '.pdf,.docx,.xlsx,.pptx';

export function Dropzone({ onFileSelected, accept = DEFAULT_ACCEPT }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [dragOver, setDragOver] = useState(false);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files?.[0];
    if (f) onFileSelected(f);
    // Reset so picking the same file twice still fires onChange
    e.target.value = '';
  };

  const handleDrop = (e: DragEvent<HTMLLabelElement>) => {
    e.preventDefault();
    setDragOver(false);
    const f = e.dataTransfer.files?.[0];
    if (f) onFileSelected(f);
  };

  return (
    <label
      className={`dropzone${dragOver ? ' dragover' : ''}`}
      onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
      onDragLeave={() => setDragOver(false)}
      onDrop={handleDrop}
    >
      <div className="dropzone-icon" aria-hidden="true">📄</div>
      <div className="dropzone-text">
        <strong>Clique para selecionar</strong> ou arraste seu arquivo aqui
      </div>
      <div className="dropzone-hint">Suportado: PDF, DOCX, XLSX, PPTX · Máx. 20 MB</div>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        onChange={handleChange}
      />
    </label>
  );
}
